// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Eg","centerLink":"Fg","productSection":"Gg","item":"Hg","ctaButton":"Ig"};